import {
  AssignmentStatusByStudentItem,
  RecitationStatusBookItem,
} from '../../../../constants/types/lms/recitation/type';
import TextWinds from '../../../common/TextWinds';
import { Button } from 'antd';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getRecitationStatusList } from '../../../../api/utils/lms/recitation/api';
import { useAppDispatch } from '../../../../store/hook';
import { getErrorMessages } from '../../../../api/utils/util-func';
import { openAlert } from '../../../../store/features/modalSlice';
import RecitationResult from '../../../recitation/RecitationResult';

interface StatusByStudentContentsProps {
  selectedStudent: AssignmentStatusByStudentItem;
  handleBack: () => void;
}

/**
 * 개편 LMS (교사) - AI인증제 관리 > AI인증제 현황 페이지 > 학생별 과제 현황
 */
const StatusByStudentContents = ({
  selectedStudent,
  handleBack,
}: StatusByStudentContentsProps) => {
  const { classId } = useParams();

  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [assignmentStatusList, setAssignmentStatusList] = useState<
    RecitationStatusBookItem[]
  >([]);

  const fetchAssignmentStatusList = async () => {
    if (!selectedStudent) return;

    try {
      setIsLoading(true);

      const response = await getRecitationStatusList({
        classId,
        studentId: selectedStudent.id,
      });

      setAssignmentStatusList(response.books ?? []);
    } catch (error) {
      dispatch(openAlert({ message: getErrorMessages(error) }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedStudent) {
      fetchAssignmentStatusList();
    }
  }, [selectedStudent]);

  return (
    <>
      <div className="mb-5 flex items-center gap-3">
        <Button
          type="default"
          className="flex shrink-0 items-center gap-2 rounded-lg px-5"
          onClick={() => {
            handleBack();
          }}
        >
          ← 학생 목록으로
        </Button>

        <div className="flex min-w-0 flex-1 items-center justify-between gap-3">
          <TextWinds type="title_h3" className="min-w-0 truncate">
            {selectedStudent.name}
          </TextWinds>
        </div>
      </div>

      {!isLoading && assignmentStatusList.length === 0 ? (
        <div className="flex h-[280px] items-center justify-center rounded-xl border border-dashed border-gray4 bg-gray0 px-4 text-center">
          <TextWinds type="content_body2" color="gray6">
            조회된 과제 현황이 없습니다.
          </TextWinds>
        </div>
      ) : (
        <div className="w-full rounded-xl border border-gray3 bg-white px-4 py-4">
          <RecitationResult isTeacherAccount studentUid={selectedStudent.uid} />
        </div>
      )}
    </>
  );
};

export default StatusByStudentContents;
